import { getWithRootPathGetter, replacePathParams } from '@/api/utils';

const withRoot = getWithRootPathGetter('/opobff/opo-platform/opo-users');

export const opobffUsersApiPaths = {
  users: withRoot(''),
  userById: withRoot('/:contactId'),
  operationByCorrelationId: withRoot('/operations/:correlationId'),
} as const;

export const getOpobffUsersApiUrl = {
  users: () => opobffUsersApiPaths.users,
  userById: (contactId: string) => replacePathParams(opobffUsersApiPaths.userById, { contactId }),
  operationByCorrelationId: (correlationId: string) =>
    replacePathParams(opobffUsersApiPaths.operationByCorrelationId, { correlationId }),
};
